module.exports = __webpack_public_path__ + "img/ZZT1--.680fdcd6.png";